import { audienceSchema, jObjectListSchema } from './object';
import { z } from 'zod';

export const jDiapazoneListSchema = jObjectListSchema.extend({
    dateStart: z.string(),
    animatedMeetingContent: z.record(z.unknown()),
    _extend: z.object({
        status: z.string(),
        statusValue: z.literal(1).or(z.literal(2)).or(z.literal(3)),
        date: z.string(),
    }),
    _audience: audienceSchema.array(),
    _audienceLeft: z.number(),
});
export type jDiapazoneList = z.infer<typeof jDiapazoneListSchema>;
